export default {
  "content": "<title>cross-small-gray</title><path d=\"M8.946 0L5 3.946 1.054 0 0 1.054 3.946 5 0 8.946 1.054 10 5 6.054 8.946 10 10 8.946 6.054 5 10 1.054z\" fill=\"#7E8391\"/>",
  "attrs": {
    "width": "10",
    "height": "10",
    "viewBox": "0 0 10 10",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};